import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import { callApiAsync, postAddAccessory } from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";

const validationSchema = yup.object().shape({
  newAccessory: yup
    .string()
    .required("Este campo es obligatorio")
    .min(1, "Este campo no puede estar vacío")
});

const AddAccessory = ({
  open,
  close,
  setAccessoryOptions,
  brandIdSelected,
  accessoryOptions,
  onStart,
  onFinish
}) => {
  const userId = useSelector((state) => state.userData.userData?.id);
  const actionRef = useRef("idle");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open || actionRef.current !== "closing") return;
    actionRef.current = "idle";
    setIsSubmitting(false);
    onFinish?.();
  }, [open, onFinish]);

  const handleAccessorySubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (actionRef.current !== "idle" || (onStart && !onStart())) return;
    actionRef.current = "running";
    setIsSubmitting(true);
    try {
      await handleSubmit(onSubmit)(event);
    } finally {
      if (actionRef.current === "running") {
        actionRef.current = "idle";
        setIsSubmitting(false);
        onFinish?.();
      }
    }
  };
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const {
    control,
    getValues,
    reset,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const handleClose = () => {
    if (actionRef.current !== "idle") return;
    finishClose();
  };

  const finishClose = () => {
    reset();
    close();
  };

  const onSubmit = async (formData) => {
    const newAccessoryName = formData.newAccessory.trim().toLowerCase();

    if (!brandIdSelected) {
      setToastMessage("No hay una marca seleccionada.");
      setShowToast(true);
      return;
    }

    const currentAccessoryOptions = Array.isArray(accessoryOptions)
      ? accessoryOptions
      : [];

    const isDuplicate = currentAccessoryOptions.some(
      (accessory) => accessory.name.trim().toLowerCase() === newAccessoryName
    );

    if (isDuplicate) {
      setToastMessage("Ya existe un accesorio con este nombre.");
      setShowToast(true);
      return;
    }

    await callApiAsync(
      () =>
        postAddAccessory({
          requestId: crypto.randomUUID(),
          userId,
          name: formData.newAccessory,
          brandId: brandIdSelected
        }),
      (data) => {
        if (data.answer.result === true) {
          actionRef.current = "closing";
          setAccessoryOptions(data.answer.list);
          finishClose();
        } else {
          setToastMessage("Error al agregar el accesorio.");
          setShowToast(true);
        }
      }
    );
  };

  return (
    <>
      <ToastNotification
        severity="warn"
        summary={toastMessage}
        detail=""
        showToast={showToast}
        setShowToast={setShowToast}
      />
      <ModalComponent
        open={open}
        title="Agregar Nuevo Accesorio"
        handleClose={handleClose}
        actions={<></>}
      >
        <form onSubmit={handleAccessorySubmit}>
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <p className="create-label ml-0">Nuevo accesorio:</p>
              <FormTextField
                name="newAccessory"
                control={control}
                error={errors.newAccessory}
                margin={"0"}
                disabled={isSubmitting}
              />
            </Grid>
          </Grid>
          <div className="j-center">
            <LaddaButton
              fontSize={"12px"}
              height={"32px"}
              variant="contained"
              margin={"20px 0"}
              type="submit"
              disabled={isSubmitting}
              loading={isSubmitting}
            >
              <p className="button_text">Crear Accesorio</p>
            </LaddaButton>
          </div>
        </form>
      </ModalComponent>
    </>
  );
};

export default AddAccessory;
